import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateComponent } from './components/date/date.component';
import { BsDatepickerConfig, BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { plLocale } from 'ngx-bootstrap/locale';
import { getDatepickerConfig } from '@shared/modules/form/modules/date/functions/get-datepicker-config.function';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateSimpleComponent } from './components/date-simple/date-simple.component';
import { TimeModule } from '@shared/modules/form/modules/time/time.module';

defineLocale('pl', plLocale);

@NgModule({
  declarations: [DateComponent, DateSimpleComponent],
  exports: [
    DateComponent,
    DateSimpleComponent
  ],
  imports: [
    CommonModule,
    BsDatepickerModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    TimeModule
  ],
  providers: [{provide: BsDatepickerConfig, useFactory: getDatepickerConfig}]
})
export class DateModule {
  constructor(private bsLocaleService: BsLocaleService) {
    this.bsLocaleService.use('pl');
  }
}
